/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import EventEmitter from 'eventemitter3';

/**
 * @import { TargetController, TargetControllerEventTypes } from '.'
 * @import { ContentTask } from '../../content/task/content-task'
 * @import { ContentTaskCronFactory } from '../../content/task/cron/content-task-cron-factory'
 */

/**
 * @implements {TargetController}
 */
export class CalendarTargetController {
  /**
   * @param {ContentTaskCronFactory} contentTaskCronFactory
   * @param {ContentTask[]} contentTasks Obsahové úlohy pro daný target.
   */
  constructor(contentTaskCronFactory, contentTasks) {
    this.contentTaskCronFactory = contentTaskCronFactory;
    this.contentTasks = contentTasks;

    /** @type {EventEmitter<TargetControllerEventTypes>} */
    this.emitter = new EventEmitter();

    const contentTaskCron = this.contentTaskCronFactory.create(contentTasks);
    this.onContentTaskChanged = this.onContentTaskChanged.bind(this);

    this.contentTaskCron = contentTaskCron;
    contentTaskCron.on('taskChanged', this.onContentTaskChanged);

    const contentTask = /** @type {ContentTask} */ (
      contentTaskCron.getCurrentTask()
    );
    /** @type {ContentTask | null} */
    this.contentTask = contentTask;
  }

  destroy() {
    this.contentTaskCron.off('taskChanged', this.onContentTaskChanged);
  }

  /** @type {TargetController['getContent']} */
  getContent() {
    return this.contentTask;
  }

  /** @type {TargetController['off']} */
  off(...args) {
    this.emitter.off(...args);
  }

  /** @type {TargetController['on']} */
  on(...args) {
    this.emitter.on(...args);
  }

  /**
   * Zareaguje na událost se změnou obsahové úlohy z CRON plánovače.
   * @param {ContentTask | null} contentTask
   * @private
   */
  onContentTaskChanged(contentTask) {
    this.content = contentTask;
    this.emitter.emit('contentChanged', contentTask);
  }
}
